module.exports = __webpack_public_path__ + "media/img/frontend_application/upload-placeholder-d18c24836fb75e853f3f0c6e434bd2f8.svg";